// extracted by mini-css-extract-plugin
export default {"fileContainer":"certificationPublicFile_fileContainer__eK8Si","fileItem":"certificationPublicFile_fileItem__pwioa"};